// Module
var code = "<p>[# connection-error] Мы не смогли установить соединение WebSocket с полной нодой.</p> <p>Возможные причины: TODO</p> <ul> <li>причина #1</li> <li>причина #2</li> </ul> ";
// Exports
export default code;